module.exports = __webpack_public_path__ + "files/54d4714db8fc9a182a3324358f88ac93.png";